import { Column, Table } from 'components/Table/Table'
import { BodyTableCell, TableRow } from 'components/Table/Table.styled'
import { Box } from '@mui/material'
import theme from 'lib/theme'
import Place from 'types/model/place'
import { Order } from 'types/api/order'
import { Pagination } from 'types/model/common'
import { ReactElement, ReactNode } from 'react'
import { Product } from 'types/model/product'
import { MasterProduct, SearchProduct } from 'types/api/product'

interface ListingPageProps<T> {
  tableWidth?: string
  header?: ReactNode
  columns: Column<string>[]
  pagination?: Pagination
  handleNavigate?: (id: string) => void
  listItems: T[]
  query?: string
  table?: string
  page?: number
  handleChangePage?: (newPage: number) => void
  displayValues: (order: T, id: string) => string | T | ReactElement
  productTable?: boolean
  refundProductState?: Product[] | []
  alignTop?: boolean
  tableHeight?: string
}

export const ListingPage = <
  T extends Order | Place | Product | MasterProduct | SearchProduct
>({
  tableWidth,
  header,
  table,
  columns,
  pagination,
  handleNavigate,
  listItems,
  query,
  page,
  handleChangePage,
  displayValues,
  productTable,
  refundProductState,
  alignTop,
  tableHeight,
}: ListingPageProps<T>) => {
  return (
    <Box
      sx={{
        height: tableHeight ?? 'calc(100% - 64px)',
        width: tableWidth,
        marginTop: 0,
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.between('xs', 'sm')]: {
          mx: 0,
        },
      }}>
      {header}
      {!(listItems.length === 0 && query) && (
        <Table
          tableHeight={tableHeight || 'calc(100vh - 184px)'}
          ariaLabel={table as string}
          pagination={pagination}
          columns={columns}
          page={page}
          handleChangePage={handleChangePage}>
          {listItems.map((row) => {
            const placeType = row as Place
            return (
              <TableRow
                productTable={Boolean(productTable)}
                hover
                role='checkbox'
                tabIndex={-1}
                key={row.id}
                onClick={() =>
                  handleNavigate?.(
                    placeType.masterId ? placeType.masterId : row.id
                  )
                }>
                {columns.map((column, index) => {
                  const value = displayValues(row, column.id)
                  return (
                    <BodyTableCell
                      alignTop={alignTop}
                      selected={Boolean(
                        refundProductState &&
                          refundProductState.find((p) => p.id === row.id)
                      )}
                      cellWidth={column.cellWidth}
                      index={index}
                      key={column.id as string}
                      align={column.align}>
                      {value || ''}
                    </BodyTableCell>
                  )
                })}
              </TableRow>
            )
          })}
        </Table>
      )}
    </Box>
  )
}
